import SingleSelectDropdown from "../../../../Components/CustomDropdowns/SingleSelectDropdown";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

const JobsTypeDropdown = (props) => {
  const { jobsType, setJobsType } = props;

  const { t } = useTranslation("page-my-jobs");

  const jobTypeOptions = [
    { value: "active", label: t("in_progress") },
    { value: "completed", label: t("completed") },
    { value: "missed", label: t("missed_last_30_days") },
  ];

  return (
    <Box>
      <SingleSelectDropdown
        value={jobsType}
        onChange={setJobsType}
        options={jobTypeOptions}
        horizontalAnchorOrigin="right"
        sx={{
          button: {
            backgroundColor: "rgba(255, 255, 255, 1)",
            gap: "12px",
            paddingX: "12px",
            ":hover": { backgroundColor: "rgba(255, 255, 255, 1)" },
          },
          menuPaper: {
            minWidth: "max-content",
          },
        }}
      />
    </Box>
  );
};

export default JobsTypeDropdown;
